module.exports = __webpack_public_path__ + "assets/img/left_1.9581c8df.png";